<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M5 7.75A1.75 1.75 0 016.75 6h10.5A1.75 1.75 0 0119 7.75v2a2.25 2.25 0 110 4.5v2A1.75 1.75 0 0117.25 18H6.75A1.75 1.75 0 015 16.25v-2a2.25 2.25 0 110-4.5z"
    />
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5v9" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M9.5 9.75h.01M9.5 14.25h.01" />
  </svg>
</template>
